export const enum ButtonTypeEnum {
    ACTION = 'button',
    LINK = 'link',
    NAVIGATION = 'navigation',
    SUBMIT = 'submit'
};
  